import React from 'react'
import './success.css'
import verifiedicon from '../../../assets/img/verifiedb.svg'
import { NavLink } from 'react-router-dom';
import logo from '../../../assets/img/b-logo.svg'
import { Row, Col } from 'antd';

const Success = ({ successful }) => {
    return(
        <Col className={`gutter-row success ${successful === true ? 'show_success' : 'hide_success'}`} xs = {{ span: 24 }} sm = {{ span: 24 }} md = {{ span: 24 }} lg = {{ span: 24 }} xl ={{ span: 24 }}>

        <div className="playarone">
            <NavLink exact to="/" >
                <img src={logo} alt="" />
            </NavLink>
            
            <NavLink exact to="/sign-in" >
                <p>Already have an account? <span>Sign In</span></p>
            </NavLink>
        </div>

        <Row gutter={[16, 24]} className="signup_step3_container">

            <Col xs = {{ span: 24 }} sm = {{ span: 22 }} md = {{ span: 18 }} lg = {{ span: 14 }} xl ={{ span: 12 }}>

                <div className="success_holder">
                    <img src={verifiedicon} alt="" style={{ width: '30px' }}/>

                    <h3>Signup Successful !!!</h3>

                    <div className="success_congrats">
                        <p>Check your email to confirm <br /> your account and start using Playarone.</p>
                    </div>

                </div>

            </Col>

        </Row>
        
    </Col>
    );
}

export default Success;